<template>
  <div class="action-overlay">
    <div class="container">
      <div class="item">
        <span v-for="(emoji, index) in emojis" :key="index">
          <img :src="emoji.src" class="emoji" @click="setResponse(emoji.pattern)" />
        </span>
      </div>
      <div class="action">
        <button class="cancel" @click="close">キャンセル</button>
      </div>
    </div>
  </div>  
</template>
<script setup>
import _emojis from '../js/emoji.js';
import { defineEmits, ref } from 'vue';

const emits = defineEmits(["add-emoji"])

const emojis = ref(_emojis)

const setResponse = (val) =>{
  emits('add-emoji', val)
}
const close = () => {
  emits('add-emoji')
}
</script>